import React from "react";
import "./EduStats.css";
import CountUp from "../countUp/CountUp";
import Reveal from "../reveal/Reveal";
import { certifications, competitiveSites, degrees } from "../../portfolio";

const stats = [
  { label: "Degree", value: degrees.degrees.length, icon: "🎓" },
  { label: "Certifications", value: certifications.certifications.length, icon: "📜" },
  { label: "Learning platforms", value: competitiveSites.competitiveSites.length, icon: "🌐" },
];

export default function EduStats() {
  return (
    <div className="edu-stats">
      {stats.map((s, i) => (
        <Reveal key={s.label} delay={i * 100} className="reveal-fill">
          <div className="edu-stat">
            <span className="edu-stat-icon" aria-hidden="true">{s.icon}</span>
            <strong>
              <CountUp to={s.value} />
            </strong>
            <span className="edu-stat-label">{s.label}</span>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
